import { useState } from 'react'
import { MailOutlined } from '@ant-design/icons'
import { Button, Form, Input, message, Modal, theme, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { errorResponse } from '../../lib/errorResponse'
import { useForm } from 'antd/lib/form/Form'

export default function ForgotPasswordForm({
  sendResetPassword,
  prefillEmail,
}) {
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form] = useForm()
  const { token } = theme.useToken()
  const { t } = useTranslation()

  async function handleSubmit(values) {
    try {
      setLoading(true)
      await sendResetPassword(values.email)
      message.success(t('frontend:auth.resetEmailSent'))
      setLoading(false)
      setVisible(false)
    } catch (error) {
      setLoading(false)
      switch (error.code) {
        case 'auth/invalid-email':
          message.error(t('frontend:auth.emailInvalid'))
          break
        case 'auth/user-not-found':
          message.error(t('frontend:auth.noUserWithEmail'))
          break
        case 'functions/resource-exhausted':
          // Backend rate-limited the password-reset email (Firebase Auth
          // throttling). Show the friendly "too many attempts" message instead
          // of the generic error toast, and don't report it to Sentry — it's an
          // expected, handled condition. CL-WEBAPP-JF.
          message.error(t('frontend:auth.tooManyAttempts'))
          break
        default:
          errorResponse(error)
          break
      }
    }
  }

  return (
    <div>
      <Button
        style={{
          display: 'block',
          fontSize: '12px',
          margin: '15px 0 0 0',
          padding: 0,
          height: 'auto',
          border: 'none',
        }}
        type="link"
        onClick={() => setVisible(true)}
      >
        {t('frontend:auth.forgotPasswordQuestion')}
      </Button>
      <Modal
        title={t('frontend:auth.forgotPassword')}
        open={visible}
        onOk={() => form.submit()}
        okText={t('frontend:auth.resetPasswordAction')}
        onCancel={() => setVisible(false)}
        confirmLoading={loading}
        width={450}
      >
        <Form
          form={form}
          onFinish={handleSubmit}
          initialValues={{ email: prefillEmail }}
        >
          <Form.Item
            name="email"
            style={{ marginBottom: 10 }}
            rules={[
              {
                required: true,
                message: t('frontend:auth.enterYourEmail'),
              },
              {
                type: 'email',
                message: t('frontend:auth.enterValidEmail'),
              },
            ]}
          >
            <Input
              prefix={
                <MailOutlined style={{ color: token.colorTextQuaternary }} />
              }
              placeholder="Email"
              type="email"
            />
          </Form.Item>
          <Typography.Text type="secondary">
            {t('frontend:auth.resetPasswordHint')}
          </Typography.Text>
        </Form>
      </Modal>
    </div>
  )
}
